import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const recipesApi = createApi({
  reducerPath: 'recipesQueries',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Recipes', 'RecipeDetails', 'RecipeFilters'],
  endpoints: (builder) => ({
    searchRecipes: builder.query({
      query: (params) => ({
        url: 'recipes/get-recipes',
        params: { params: JSON.stringify(params) },
      }),
      providesTags: ['Recipes'],
    }),
    getRecipeDetails: builder.query({
      query: (id) => `recipes/${id}`,
      providesTags: ['RecipeDetails'],
    }),
    getUserRecipeFilters: builder.query({
      query: () => 'recipes/user/filters',
      providesTags: ['RecipeFilters'],
    }),
    saveUserRecipeFilters: builder.mutation({
      query: (filters) => ({
        url: 'recipes/user/filters',
        method: 'PUT',
        body: filters,
      }),
      invalidatesTags: ['RecipeFilters'],
    }),
    recipeFavoriteAdd: builder.mutation({
      query: ({ id }) => ({
        url: `users/recipe-favorite-add/${id}`,
        method: 'POST',
      }),
    }),
    recipeFavoriteRemove: builder.mutation({
      query: ({ id }) => ({
        url: `users/recipe-favorite-remove/${id}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useSearchRecipesQuery,
  useGetRecipeDetailsQuery,
  useGetUserRecipeFiltersQuery,
  useSaveUserRecipeFiltersMutation,
  useRecipeFavoriteAddMutation,
  useRecipeFavoriteRemoveMutation,
} = recipesApi;
